(function(){
  var header=document.querySelector('[data-hdr]');
  var sections=document.querySelectorAll('[data-bg]');
  var tick=false;
  function up(){
    var probe=header.offsetHeight*0.5;
    var current='light';
    for(var i=0;i<sections.length;i++){
      var r=sections[i].getBoundingClientRect();
      if(r.top<=probe && r.bottom>probe){ current=sections[i].getAttribute('data-bg'); break; }
    }
    header.setAttribute('data-t', current==='dark'?'light':'dark');
    header.setAttribute('data-scrolled', (window.scrollY||document.documentElement.scrollTop||0) > 10 ? 'true' : 'false');
    tick=false;
  }
  function on(){if(!tick){requestAnimationFrame(up);tick=true;}}
  addEventListener('scroll',on,{passive:true});
  addEventListener('resize',on);
  up();
  var _hero=document.querySelector('[data-hero]');
  if(_hero){requestAnimationFrame(function(){requestAnimationFrame(function(){_hero.classList.add('ready');});});}

  var burger=document.querySelector('.burger');
  var menu=document.querySelector('[data-menu]');
  burger.addEventListener('click',function(){
    var open=menu.classList.toggle('open');
    menu.setAttribute('aria-hidden', open?'false':'true');
    document.body.style.overflow=open?'hidden':'';
    if(open){header.setAttribute('data-t','dark');}else{up();
      menu.querySelectorAll('[data-acc]').forEach(function(o){o.setAttribute('aria-expanded','false');o.nextElementSibling.style.maxHeight=null;});}
  });
  menu.querySelectorAll('[data-acc]').forEach(function(h){
    h.addEventListener('click',function(){
      var exp=h.getAttribute('aria-expanded')==='true';
      menu.querySelectorAll('[data-acc]').forEach(function(o){o.setAttribute('aria-expanded','false');o.nextElementSibling.style.maxHeight=null;});
      if(!exp){h.setAttribute('aria-expanded','true');var p=h.nextElementSibling;p.style.maxHeight=p.scrollHeight+'px';}
    });
  });

  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});

  // Double-tap mobile : 1er tap = preview 2e image, 2e tap = naviguer
  document.querySelectorAll('[data-media]').forEach(function(media){
    media.addEventListener('click',function(e){
      var card=media.closest('.card');
      // Sur écrans avec hover, on laisse passer (hover gère la preview)
      if(matchMedia('(hover:hover)').matches) return;
      if(!card.classList.contains('previewed')){
        e.preventDefault();
        // retirer la classe des autres cartes
        document.querySelectorAll('.card.previewed').forEach(function(c){ if(c!==card) c.classList.remove('previewed'); });
        card.classList.add('previewed');
      }
    });
  });
  // ----- Format monétaire (window.__money) — requis par la sync de prix PDP / Scalapay -----
  // (Le panier drawer est géré par une application externe : pas de drawer custom ici.)
  (function(){
    var fmt=window.CART_MONEY_FORMAT||'{{amount}} €';
    function formatMoney(cents){
      function fwd(n,p,t,d){n=(n/100).toFixed(p);var parts=n.split('.');var head=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t);return head+(parts[1]?d+parts[1]:'');}
      var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/); if(!m) return fmt; var v;
      switch(m[1]){
        case 'amount': v=fwd(cents,2,',','.'); break;
        case 'amount_no_decimals': v=fwd(cents,0,',',''); break;
        case 'amount_with_comma_separator': v=fwd(cents,2,'.',','); break;
        case 'amount_no_decimals_with_comma_separator': v=fwd(cents,0,'.',','); break;
        case 'amount_with_space_separator': v=fwd(cents,2,' ',','); break;
        case 'amount_no_decimals_with_space_separator': v=fwd(cents,0,' ',''); break;
        default: v=fwd(cents,2,',','.');
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
    }
    try{ window.__money=formatMoney; }catch(e){}
  })();

   // ----- Ajout au panier en AJAX (pas de navigation) → Moon Bundle ouvre SON drawer -----
  (function(){
    var pForm=document.querySelector('.pdp-form');
    if(!pForm) return;
    // Racine du marche : "/" en France, "/en/" ailleurs. Sans elle, Moon Bundle
    // ne voit pas passer l'ajout et n'ouvre pas son drawer.
    var ROOT=(window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    pForm.addEventListener('submit',function(e){
      e.preventDefault();                         // empêche l'envoi natif → pas de page /cart
      var btn=pForm.querySelector('[data-add]'); if(btn) btn.disabled=true;
      fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(pForm),credentials:'same-origin'})
        .then(function(r){return r.json();})
        .then(function(){
          if(btn) btn.disabled=false;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function(){ if(btn) btn.disabled=false; });
    });
  })();

  // ----- PAGE PRODUIT (galerie sticky + variantes + accordéons) -----
  (function(){
    var pdp=document.querySelector('.pdp');
    if(!pdp) return;
    var gallery=document.querySelector('.pdp-gallery')||pdp;

    // Navigation galerie produit : flèches (desktop) + points indicateurs
    (function(){
      var pv=pdp.querySelector('[data-pdp-viewport]'); if(!pv) return;
      var dots=pdp.querySelectorAll('[data-pdp-dots] .pdp-dot');
      var prevB=pdp.querySelector('[data-pdp-prev]'), nextB=pdp.querySelector('[data-pdp-next]');
      var ticking=false;
      function idx(){ return pv.clientWidth ? Math.round(pv.scrollLeft / pv.clientWidth) : 0; }
      function sync(){ ticking=false; var i=idx(); for(var k=0;k<dots.length;k++){ dots[k].classList.toggle('is-active', k===i); } }
      pv.addEventListener('scroll', function(){ if(!ticking){ ticking=true; requestAnimationFrame(sync); } }, {passive:true});
      if(prevB) prevB.addEventListener('click', function(){ pv.scrollBy({left:-pv.clientWidth, behavior:'smooth'}); });
      if(nextB) nextB.addEventListener('click', function(){ pv.scrollBy({left:pv.clientWidth, behavior:'smooth'}); });
    })();

    // Galerie sticky : révélation des images au scroll
    function initPin(sc){
      var pin=sc.querySelector('.pdp-pin'); if(!pin) return;
      var fr=pin.querySelector('.pdp-frame'); if(!fr) return;
      var pfs=fr.querySelectorAll('.pf'); var vh=fr.offsetHeight;
      var rect=sc.getBoundingClientRect();
      var rel=Math.min(Math.max(-rect.top,0), sc.offsetHeight-pin.offsetHeight);
      for(var j=1;j<pfs.length;j++){
        var local=Math.min(Math.max((rel-(j-1)*vh)/vh,0),1);
        pfs[j].style.transform='translateY('+((1-local)*100)+'%)';
      }
    }
    function pins(){ document.querySelectorAll('.pdp-scroll').forEach(initPin); }
    function layoutPins(){
      document.querySelectorAll('.pdp-scroll').forEach(function(sc){
        var pin=sc.querySelector('.pdp-pin'); if(!pin) return; var fr=pin.querySelector('.pdp-frame');
        var n=parseInt(sc.getAttribute('data-images'),10)||1;
        sc.style.height=(pin.offsetHeight + (n-1)*fr.offsetHeight)+'px';
      });
      pins();
    }
    addEventListener('scroll',pins,{passive:true});
    addEventListener('resize',layoutPins);
    addEventListener('load',layoutPins);
    layoutPins();

    // Bascule produit / tenue portée + coverflow
    var galP=document.querySelector('.pdp-set[data-set="product"]');
    var galW=document.querySelector('.pdp-set[data-set="worn"]');
    var cf=document.querySelector('[data-cf]'), cfItems=[], cfCur=0, cfN=0, cfDots=[];
    function cfLayout(){
      if(!cf) return; var w=cf.offsetWidth, h=cf.offsetHeight; if(!w) return;
      for(var d=0;d<cfDots.length;d++){ cfDots[d].classList.toggle('is-active', d===cfCur); }
      cfItems.forEach(function(it,i){
        var o=i-cfCur; if(o>cfN/2)o-=cfN; if(o<-cfN/2)o+=cfN; var ao=Math.abs(o), s=o<0?-1:1;
        var x,y,sc,op,z;
        if(ao===0){x=0;y=h*0.04;sc=1;op=1;z=30;}
        else if(ao===1){x=s*w*0.32;y=h*0.02;sc=0.55;op=1;z=20;}
        else if(ao===2){x=s*w*0.19;y=-h*0.07;sc=0.38;op=0.4;z=10;}
        else {x=s*w*0.19;y=-h*0.07;sc=0.3;op=0;z=1;}
        it.style.transform='translate(-50%,-50%) translateX('+x+'px) translateY('+y+'px) scale('+sc+')';
        it.style.opacity=op; it.style.zIndex=z;
        it.style.pointerEvents=(ao>=1&&ao<=2)?'auto':'none';
      });
    }
    var cfNudged=false, cfReduce=(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function cfNudge(){
      if(cfNudged||cfN<2||cfReduce) return; cfNudged=true;
      setTimeout(function(){ cfCur=(cfCur+1)%cfN; cfLayout(); setTimeout(function(){ cfCur=(cfCur-1+cfN)%cfN; cfLayout(); },560); },380);
    }
    var cfHint=document.querySelector('.cf-hint');
    function hideHint(){ if(cfHint) cfHint.classList.add('is-hidden'); }
    if(cf){
      cfItems=Array.prototype.slice.call(cf.querySelectorAll('.cf-item')); cfN=cfItems.length;
      cfDots=Array.prototype.slice.call(document.querySelectorAll('[data-cf-dots] .pdp-dot'));
      cfItems.forEach(function(it,i){ it.addEventListener('click',function(){cfCur=i;cfLayout();hideHint();}); });
      cf.style.cursor='grab';
      var sx=null;
      cf.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
      cf.addEventListener('touchend',function(e){ if(sx===null)return; var dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>40){ cfCur=(dx<0?cfCur+1:cfCur-1+cfN)%cfN; cfLayout(); hideHint(); } sx=null; });
      // glisser à la souris (desktop)
      var px=null;
      cf.addEventListener('pointerdown',function(e){ if(e.pointerType==='mouse'){ px=e.clientX; cf.style.cursor='grabbing'; } });
      cf.addEventListener('pointerup',function(e){ if(px===null)return; var dx=e.clientX-px; if(Math.abs(dx)>40){ cfCur=(dx<0?cfCur+1:cfCur-1+cfN)%cfN; cfLayout(); hideHint(); } px=null; cf.style.cursor='grab'; });
      addEventListener('resize',cfLayout);
    }
    document.querySelectorAll('[data-gtoggle]').forEach(function(b){
      b.addEventListener('click',function(){
        var t=b.getAttribute('data-target');
        if(t==='worn'){ if(galP)galP.setAttribute('hidden',''); if(galW)galW.removeAttribute('hidden'); }
        else{ if(galW)galW.setAttribute('hidden',''); if(galP)galP.removeAttribute('hidden'); }
        window.scrollTo({top:gallery.offsetTop,behavior:'auto'});
        if(t==='worn'){ requestAnimationFrame(function(){ cfLayout(); cfNudge(); }); }
      });
    });

    // Accordéons (paiement + description)
    document.querySelectorAll('[data-acc2]').forEach(function(h){
      h.addEventListener('click',function(){
        var exp=h.getAttribute('aria-expanded')==='true';
        h.setAttribute('aria-expanded',exp?'false':'true');
        var p=h.nextElementSibling; if(p) p.style.maxHeight=exp?null:p.scrollHeight+'px';
        var sp=h.querySelector('span'); if(sp) sp.textContent=exp?'+':'−';
      });
    });

    // Popup guide des tailles
    var sgmodal=document.querySelector('[data-sizeguide]');
    if(sgmodal){
      function sgOpen(){ sgmodal.hidden=false; document.body.style.overflow='hidden'; }
      function sgClose(){ sgmodal.hidden=true; document.body.style.overflow=''; }
      document.querySelectorAll('[data-sizeguide-open]').forEach(function(b){ b.addEventListener('click',sgOpen); });
      sgmodal.querySelectorAll('[data-sizeguide-close]').forEach(function(b){ b.addEventListener('click',sgClose); });
      addEventListener('keydown',function(e){ if(e.key==='Escape'&&!sgmodal.hidden) sgClose(); });
    }

    // Sélection de variante (couleur + taille)
    var form=document.querySelector('.pdp-form');
    var variants=[]; var dataEl=document.querySelector('[data-variants]');
    if(dataEl){ try{ variants=JSON.parse(dataEl.textContent); }catch(e){} }
    var state={color:pdp.getAttribute('data-sel-color')||null, size:pdp.getAttribute('data-sel-size')||null};
    function findVariant(){
      for(var i=0;i<variants.length;i++){
        var opts=variants[i].options||[];
        var okC=(state.color==null)||opts.indexOf(state.color)>-1;
        var okS=(state.size==null)||opts.indexOf(state.size)>-1;
        if(okC&&okS) return variants[i];
      }
      return null;
    }
    function update(){
      var v=findVariant();
      var idInput=form&&form.querySelector('input[name="id"]');
      var cart=document.querySelector('.pdp-cart');
      if(v){
        if(idInput) idInput.value=v.id;
        if(window.__money) document.querySelectorAll('[data-price]').forEach(function(p){p.textContent=window.__money(v.price);});
        if(cart){ cart.disabled=!v.available; }
      } else if(cart){ cart.disabled=true; }
    }
    document.querySelectorAll('.sw[data-color]').forEach(function(b){
      b.addEventListener('click',function(){
        state.color=b.getAttribute('data-color');
        document.querySelectorAll('.sw[data-color]').forEach(function(o){o.classList.remove('is-active');});
        b.classList.add('is-active'); update();
      });
    });
    var stog=document.querySelector('[data-size-toggle]');
    if(stog){
      var slist=document.querySelector('[data-size-list]');
      stog.addEventListener('click',function(e){e.stopPropagation();var op=slist.hidden;slist.hidden=!op;stog.setAttribute('aria-expanded',op?'true':'false');});
      slist.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
        state.size=b.getAttribute('data-size')||b.textContent.trim();
        var valEl=document.querySelector('[data-size-val]'); if(valEl) valEl.textContent=b.textContent.trim();
        slist.hidden=true; stog.setAttribute('aria-expanded','false'); update();
      });});
      document.addEventListener('click',function(){slist.hidden=true;stog.setAttribute('aria-expanded','false');});
    }
    update();

    // Scalapay : recalcule le montant N× dès que le prix de l'ATC change (ex. Moon Bundle)
    var cartBtn=document.querySelector('.pdp-cart');
    if(cartBtn){
      function moneyToCents(str){
        // extrait le DERNIER vrai montant (ex. "84,99", "2.584,99") et ignore les nombres
        // parasites du libellé du bouton (ex. "économise 25€")
        var m=(str||'').match(/\d[\d.\s ]*[.,]\d{2}(?!\d)/g);
        if(!m || !m.length) return NaN;
        var s=m[m.length-1].replace(/[^0-9.,]/g,''); if(!s) return NaN;
        var dec=Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
        var after=dec>-1?(s.length-dec-1):0; var intp, frac;
        if(dec>-1 && after>0 && after<=2){ intp=s.slice(0,dec).replace(/[.,]/g,''); frac=s.slice(dec+1).replace(/[.,]/g,''); }
        else { intp=s.replace(/[.,]/g,''); frac=''; }
        var val=parseFloat(intp+(frac?('.'+frac):'')); return isNaN(val)?NaN:Math.round(val*100);
      }
      function syncInstallments(){
        if(!window.__money) return;
        var cents=moneyToCents(cartBtn.textContent); if(isNaN(cents)) return;
        document.querySelectorAll('[data-price]').forEach(function(p){ p.textContent=window.__money(cents); });
        document.querySelectorAll('[data-installment]').forEach(function(el){ var n=parseInt(el.getAttribute('data-inst-count'),10)||3; el.textContent=window.__money(Math.round(cents/n)); });
      }
      if(window.MutationObserver){
        new MutationObserver(syncInstallments).observe(cartBtn,{childList:true,characterData:true,subtree:true});
      }
      syncInstallments();
    }
  })();

  // ----- You may also like (mélange aléatoire + limite) -----
  (function(){
    var ymal=document.querySelector('[data-ymal]');
    if(!ymal) return;
    var grid=ymal.querySelector('.grid');
    if(!grid) return;
    var cards=Array.prototype.slice.call(grid.querySelectorAll('.card'));
    if(cards.length<2) return;
    for(var i=cards.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=cards[i]; cards[i]=cards[j]; cards[j]=t; }
    var keep=parseInt(ymal.getAttribute('data-count'),10)||4;
    grid.innerHTML='';
    cards.slice(0,keep).forEach(function(c){ grid.appendChild(c); });
  })();
})();
